/**
* @file 运营中心-公司钱包
* */
<template>
  <div class="ticketStatisticsWindow">
    <custom-table @list="listFn" :paging="false" excel-type="SystemTicketStatistics" :labelWidth="140" ref="customTable"
                  :customOptions="customOptions" :columns="columns"
                  has-organization="true"
                  organization-default="true"
    >
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <div v-else-if="item.prop == 'realFee'">
          <span v-if="row.realFee" style="color: #ff9900"> ¥{{ row.realFee }}</span>
          <span v-else>-</span>
        </div>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="70px" v-slot="{ row }">
          <el-button type="text" @click="printDetails(row)">
            <i class="el-icon-printer" style="margin-left: 10px;color:#409EFF;font-size:18px;cursor: pointer;"></i>
          </el-button>

        </el-table-column>
      </template>
    </custom-table>


    <div id="printJS-form" v-if="tableData.length">
      <div style="margin-bottom: 20px">统计时间:{{params.startTime | filterTime2('YYYY-MM-DD')}} - {{params.endTime | filterTime2('YYYY-MM-DD')}}</div>
      <el-table
          :data="tableData"
          border
          style="width: 1920px">
        <el-table-column
            v-for="item in columns"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import printJS from "print-js";

export default {
  name: "ticketStatisticsWindow",
  data() {
    return {
      // 配置项
      tableData: [],
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/ticket/statistics/system',
        // 请求的参数列表
        params: {
          type: '',
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: 'daytime',
            field: 'Time',
            name: '统计时间',
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(0, 0, 0, 0)]
          },
          {
            type: "select",
            option: [],
            field: "ticketSellerId",
            props: {label: 'name', value: 'id',},
            name: "售票员",
            value: ""
          },
        ]
      },
      // 表头
      columns: [
        {prop: 'ticketSeller', label: '售票员'},
        {prop: 'orderFee', label: '售票金额'},
        {prop: 'startTicketNo', label: '开始票号'},
        {prop: 'ticketCurrentNo', label: '结束票号'},
        {prop: 'ticketNum', label: '售票张数'},
        {prop: 'refundFee', label: '退票金额'},
        {prop: 'ticketRefundNum', label: '退票张数'},
        {prop: 'retreatFee', label: '退票手续费'},
        {prop: 'insuranceFee', label: '保险金额'},
        {prop: 'insuranceNum', label: '保险张数'},
        {prop: 'ticketChangingFee', label: '改签手续费'},
        {prop: 'cashFee', label: '现金收款'},
        {prop: 'collectionCode', label: '二维码收款'},
        {prop: 'stationChargeFee', label: '站务费'},
        {prop: 'realFee', label: '实收金额'},
      ],
      flowing: '',
      params:{}
    }
  },
  async created() {

  },
  methods: {
    listFn(row){
      this.params = row
      console.log(row,32333);
    },
    /**
     * 状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1
      this.$refs.customTable.listFn();
    },
    printDetails(row) {

      this.tableData = [row]
      this.$nextTick(() => {
        html2Canvas(document.querySelector('#printJS-form'), {
          allowTaint: false,
          useCORS: false,
          height: document.querySelector('#printJS-form').outerHeight,
          width: document.querySelector('#printJS-form').outerWidth,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight
        }).then((canvas) => {
          const url = canvas.toDataURL()
          printJS({
            printable: url,
            type: 'image',
            documentTitle: ''
          })
          this.tableData = []
        })
      })
    },
  }
}
</script>

<style scoped lang="less">
.ticketStatisticsWindow {
  width: 100%;
  height: 100%;
  #printJS-form {
    background-color: white;
    top: -1100px;
    width: 1400px;
    position: fixed;
    z-index: -10
  }
}

</style>
